// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import {
  cleanAllComments,
  createComment,
  getEntityIdAndDbSet,
} from 'redux/modules/databaseDetails'

// Temp shim to support paths
const getPathIdAndDbSet = getState => ({
  dbSet: 'path',
  entityId: getState().pathDetails.get('pathId'),
})

const entityIdKey = {
  antenna: 'antennaSpecCommentId',
  radio: 'radioCommentId',
  path: 'pathCommentId',
}

const createAndUpdateComments = (formData, isPathComment) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        dbSet,
        entityId,
      } = (
        isPathComment
          ? getPathIdAndDbSet(getState)
          : getEntityIdAndDbSet(getState)
      )

      // send the comment to the API
      const newComment = await createComment(formData, dbSet, entityId)
      // clean the response and send it back to the component
      return cleanAllComments([newComment], entityIdKey[dbSet])
    })
  )
)

export default createAndUpdateComments
